// 图表 / 排行的数值排序 (2026-10-21): 条形榜单默认从大到小, 一眼看到最多的那几项; 每张图可切 低→高 / 高→低.
// 后端给的顺序不可靠 (按 code / 按首次出现 / Top N 截断前未排), 展示层统一在这里排.
// 稳定排序: 数值相同保持原顺序. 时间序列不要走这里.

/** 排序方向: desc 高→低 / asc 低→高 / none 保持传入顺序 (档位类图表的默认). */
export type SortDir = 'desc' | 'asc' | 'none';

/** 按方向排序 (不改原数组). */
export function sortByDir<T>(rows: readonly T[], value: (r: T) => number, dir: SortDir): T[] {
    if (dir === 'none') return rows.slice();
    const sign = dir === 'desc' ? -1 : 1;
    return rows
        .map((r, i) => ({ r, i, v: value(r) }))
        .sort((a, b) => sign * (a.v - b.v) || a.i - b.i)
        .map((x) => x.r);
}

/** 按 value 从大到小 (不改原数组). */
export function sortDescBy<T>(rows: readonly T[], value: (r: T) => number): T[] {
    return sortByDir(rows, value, 'desc');
}
